'use client'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@/components/ui/accordion'
import { BodyText, SectionHeading } from '@/components/ui/typography'

interface BlogFAQProps {
  faq: Array<{
    question: string
    answer: string
  }>
}

export function BlogFAQ({ faq }: BlogFAQProps) {
  if (!faq || faq.length === 0) {
    return null
  }

  return (
    <div className="border-border/50 mt-12 border-t pt-8">
      <SectionHeading className="mb-6 border-none pb-0">FAQ</SectionHeading>
      <Accordion type="multiple" className="w-full">
        {faq.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger>
              <BodyText className="text-left font-medium">
                {item.question}
              </BodyText>
            </AccordionTrigger>
            <AccordionContent>
              <BodyText className="text-muted-foreground">
                {item.answer}
              </BodyText>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  )
}
